/**
 * Order money helpers shared by the orders page and modals. Totals are always
 * NET of refunds: Σ price × (quantity − refundedQuantity). `refundedQuantity`
 * is absent on orders created before partial refunds existed, so it always
 * coalesces to 0.
 */
export function remainingQuantity(product) {
	return Math.max(0, (Number(product?.quantity) || 1) - (Number(product?.refundedQuantity) || 0));
}

export function netOrderTotal(order) {
	return order?.products?.reduce((sum, p) => sum + (Number(p.price) || 0) * remainingQuantity(p), 0) ?? 0;
}

export function orderCurrency(order) {
	return order?.products?.[0]?.currency || 'GBP';
}

export function formatAmount(amount, currency = 'GBP') {
	return new Intl.NumberFormat('en-GB', { style: 'currency', currency }).format(amount);
}

export function formatOrderPrice(order) {
	return formatAmount(netOrderTotal(order), orderCurrency(order));
}

// The wire stores refundPending as the string 'true' (DynamoDB sparse-index
// friendly); accept the boolean too for optimistic local patches.
export function isRefundPending(order) {
	return order?.refundPending === 'true' || order?.refundPending === true;
}
